<ng-container *ngIf="optionItem">
  <div class="setting-tit-box"
       [innerHTML]="optionItem.title | resize">
  </div>
  <div class="setting-des-box"
       [innerHTML]="optionItem.msg | resize">
  </div>
  <div class="close-btn"
       *ngIf="closeBtn"
       (click)="onClose.emit()">
  </div>
  <div class="setting-option-box">
    <label *ngFor="let option of optionItem.options">
      <input type="radio"
             name="{{ optionItem.id }}"
             [checked]="optionItem.getter() === option.value"
             (click)="optionItem.setter(option.value)">
      <span class="txt">
        <span [innerHTML]="option.name | resize"></span>
        <span class="star star1" *ngIf="option.etc" class="{{ option.etc }}"></span>
      </span>
    </label>
  </div>
</ng-container>
